"use client";
import Script from "next/script";
import { useCookieConsent } from "@/components/CookieContext";

export default function AnalyticsScripts() {
  const { cookiesAccepted } = useCookieConsent();

  if (!cookiesAccepted) return null;

  return (
    <>
      <Script
        strategy="afterInteractive"
        src={`https://www.googletagmanager.com/gtag/js?id=G-S5YGDB39NE`}
      />
      <Script id="gtag-init" strategy="afterInteractive">
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', 'G-S5YGDB39NE');
        `}
      </Script>
    </>
  );
}
